/**
 * Stat-significance gating used to lock brief generation and similar
 * actions while a creative has too little spend behind it for a thesis
 * to be trustworthy. See outline §6.1.
 */
export const BRIEF_CONFIDENCE_FLOOR = 0.4;

export const isBriefLocked = (node) => {
  if (!node) return true;
  if (node.status === "unexplored") return false;
  return (node.confidence ?? 0) < BRIEF_CONFIDENCE_FLOOR;
};

export const briefLockReason = (node) => {
  const pct = Math.round((node?.confidence ?? 0) * 100);
  const floor = Math.round(BRIEF_CONFIDENCE_FLOOR * 100);
  return `Locked — ${pct}% confidence below ${floor}% floor (outline §6.1)`;
};
